export const BASKET_POPUP_TEST_ID = 'basket-popup';
